import { render, staticRenderFns } from "./torrents.vue?vue&type=template&id=fcb0047e&scoped=true&"
import script from "./torrents.vue?vue&type=script&lang=js&"
export * from "./torrents.vue?vue&type=script&lang=js&"
import style0 from "./torrents.vue?vue&type=style&index=0&id=fcb0047e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb0047e",
  null
  
)

export default component.exports